import styled from 'styled-components';
import { Box } from '@rsos/components/capstone/base';

export const NotificationContainer = styled(Box).attrs({
  maxHeight: 56,
  bg: 'secondaryText',
  color: 'background',
  borderRadius: '5px',
  px: 20,
  py: 12,
  mb: 10,
})``;

export const NotificationContentWrapper = styled(Box).attrs({
  horizontal: true,
  align: 'center',
  flow: 12,
})``;
